module.exports = __webpack_public_path__ + "c7fa8020107d02c98188502739c753fa.png";